import { defaultPost, eraseCookie } from '@bikemap/js/utility'
import { gettext, modals, notifications } from '@bikemap/js/services'
import { LOGGED_IN_COOKIE } from '@bikemap/js/settings'

function handleDeleteAccountConfirm(e, modal) {
    modal.setLoading()
    defaultPost(modal.referrer.action, new FormData(modal.referrer))
        .then(({ msg, url }) => {
            if (msg) {
                notifications.show({
                    title: msg.title,
                    icon: 'i-warning-sign',
                    message: msg.content,
                    type: 'danger',
                })
            } else if (url) {
                eraseCookie(LOGGED_IN_COOKIE)
                if (location.href === url) {
                    location.reload()
                } else {
                    location.href = url
                }
            }
        })
        .catch(res => notifications.error(res.statusText))
        .finally(() => {
            modal.setLoading(false)
            modals.close()
        })
}

export function initDeleteAccountForm() {
    const form = document.getElementById('account-delete-form')
    form.addEventListener('submit', e => {
        e.preventDefault()
        let errorEl = form.querySelector('.form-field-error')
        const confirmDeletion = /** @type {HTMLInputElement} */ (form.querySelector('input[type="checkbox"]'))
        if (confirmDeletion && !confirmDeletion.checked) {
            if (!errorEl) {
                errorEl = document.createElement('p')
                errorEl.className = 'form-field-error'
                errorEl.textContent = gettext('Please check this box to delete your account.')
                confirmDeletion.parentElement.append(errorEl)
            }
        } else {
            if (errorEl) {
                errorEl.remove()
            }
            modals.show('delete-profile', {
                title: gettext('Delete Account'),
                message: (
                    gettext('Do you really want to delete your Bikemap account?') +
                    '<br><strong>' + gettext('This cannot be undone!') + '</strong>' +
                    '<span class="bm-premium-show">' +
                        '<br>' + gettext('You have an <strong>active Bikemap Premium membership</strong>.') +
                        gettext('There will be no refund for the remaining days if you delete your account now.') +
                    '</span>'
                ),
                buttons: [
                    { content: gettext('Cancel'), style: 'primary', action: 'close' },
                    { content: gettext('Confirm'), action: 'submit' },
                ],
                referrer: e.target,
                onSubmit: handleDeleteAccountConfirm,
            })
        }
    })
}
